'use client'

import { useConsentManager } from '@c15t/nextjs'
import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { useEffect, useRef } from 'react'

/**
 * Silently links the logged-in user's ID to their c15t consent subject.
 * Runs once per unique user ID (login / account switch).
 * Must be mounted inside <ConsentManagerProvider>.
 */
export function ConsentIdentitySync() {
  const { identifyUser } = useConsentManager()
  const { data: user } = useUserQuery()
  const lastLinkedId = useRef<string | null>(null)

  useEffect(() => {
    if (!user?.id) return
    if (lastLinkedId.current === user.id) return
    identifyUser({ id: user.id, identityProvider: 'coolmate' }).catch(() => {})
    lastLinkedId.current = user.id
  }, [user?.id, identifyUser])

  return null
}
